import { mapGetters } from 'vuex';
import { isValidURL } from '../helper/URLHelper';
export default {
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      accountId: 'getCurrentAccountId',
    }),
    attributes() {
      return this.$store.getters['attributes/getAttributesByModel'](
        this.attributeType
      );
    },
    customAttributes() {
      if (this.attributeType === 'conversation_attribute')
        return this.currentChat.custom_attributes || {};
      // Prefer explicit mycontact (panel/modal context) when it matches the
      // resolved id so we do not read another contact from the store (e.g.
      // currentChat.sender still set while opening overview / reports modals).
      const id = this.contactIdentifier;
      if (
        this.attributeType === 'contact_attribute' &&
        id != null &&
        id !== '' &&
        this.mycontact &&
        Number(this.mycontact.id) === Number(id)
      ) {
        return (
          this.mycontact.custom_attributes ||
          this.contact.custom_attributes ||
          {}
        );
      }
      return (
        this.contact.custom_attributes || this.mycontact.custom_attributes || {}
      );
    },
    // Postgres jsonb does not preserve key order; prefer the explicit order
    // stored on the contact when rendering selected contact attributes.
    customAttributesOrder() {
      const attributeKeys = Object.keys(this.customAttributes);
      if (this.attributeType !== 'contact_attribute') {
        return attributeKeys;
      }

      const order = this.contactCustomAttributesOrder;
      if (!Array.isArray(order) || !order.length) {
        return attributeKeys;
      }

      const ordered = order.filter(key => attributeKeys.includes(key));
      const missing = attributeKeys.filter(key => !order.includes(key));
      return ordered.concat(missing);
    },
    contactCustomAttributesOrder() {
      const storeOrder = this.contact?.custom_attributes_order;
      if (Array.isArray(storeOrder)) {
        return storeOrder;
      }

      const id = this.contactIdentifier;
      if (
        id != null &&
        id !== '' &&
        this.mycontact &&
        Number(this.mycontact.id) === Number(id) &&
        Array.isArray(this.mycontact.custom_attributes_order)
      ) {
        return this.mycontact.custom_attributes_order;
      }
      return this.mycontact?.custom_attributes_order || [];
    },
    contactIdentifier() {
      // Explicit contactId (e.g. ContactInfoPanel) must win over the inbox's
      // selected conversation sender, or custom attributes show the wrong person.
      if (this.contactId != null && this.contactId !== '') {
        return this.contactId;
      }
      return (
        this.currentChat.meta?.sender?.id ||
        this.$route.params.contactId ||
        null
      );
    },
    contact() {
      return this.$store.getters['contacts/getContact'](this.contactIdentifier);
    },
    conversationId() {
      return this.currentChat.id;
    },

    filteredAttributes() {
      return this.customAttributesOrder.map(key => {
        const item = this.attributes.find(
          attribute => attribute.attribute_key === key
        );
        if (item) {
          return {
            ...item,
            value: this.customAttributes[key],
          };
        }

        return {
          ...item,
          value: this.customAttributes[key],
          attribute_description: key,
          attribute_display_name: key,
          attribute_display_type: this.attributeDisplayType(
            this.customAttributes[key]
          ),
          attribute_key: key,
          attribute_model: this.attributeType,
          id: Math.random(),
        };
      });
    },
  },
  methods: {
    isAttributeNumber(attributeValue) {
      return (
        Number.isInteger(Number(attributeValue)) && Number(attributeValue) > 0
      );
    },
    attributeDisplayType(attributeValue) {
      if (this.isAttributeNumber(attributeValue)) {
        return 'number';
      }
      if (isValidURL(attributeValue)) {
        return 'link';
      }
      return 'text';
    },
  },
};
